import React, { useState } from 'react';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CButton
} from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
// import axios from "axios";
import {
  cilPen,
  cilPlus,
  cilTrash
} from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import AxiosInstance from 'src/components/Axios';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import CustomPagination from 'src/components/pagination/CustomPaginatiion';

const page = 1;
const postPerPage = 0;
const pageSize = 20;
// const pageSize = 10;


export async function LoaderSlider({ params }) {
  let res = await AxiosInstance.get('/sliders?page=' + page).then((response) => {
    return response;
  });
  // Фільтрація на клієнтській стороні - тільки ua або null мова
  res.data['hydra:member'] = res.data['hydra:member'].filter(page =>
    page?.language === undefined || page?.language?.id === 1
  );
  return res;
}



// const columns = [
//   {
//     field: 'id', headerName: 'ID', width: 70,
//   },
//   {
//     field: 'name', headerName: 'Назва', width: 200,
//     renderCell: (params) => {
//       const isChecked = selectedIds.includes(params.row.id);

//       return (
//         <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//           <input
//             type="checkbox"
//             checked={isChecked}
//             onChange={() => handleCheckboxToggle(params.row.id)}
//             style={{
//               accentColor: isChecked ? '#227965' : '#ccc',
//               cursor: 'pointer',
//               width: '20px',
//               height: '20px',
//             }}
//           />
//           {params.row.name}
//         </div>
//       );
//     }
//   },
//   { slug: 'type', headerName: 'Тип', width: 400 },
//   {
//     field: "action",
//     headerName: "Редагувати",
//     sortable: false,
//     renderCell: (params) => {
//       return <Link to={'/slider/update/' + params.row.id}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
//     }
//   },
// ];



const Slider = ({ user_data }) => {
  if (!Permissions(user_data, 'Slider', 'VIEW_SLIDER')) {
    return <PermissionsNoPage />;
  }
  const { data } = useLoaderData();
  const [rows, setRows] = useState(data['hydra:member']);

  //для чекбокса
  const [selectedIds, setSelectedIds] = useState([]);

  // const postPerPage = 1;
  const postPerPage = 20;

  //обробник для чекбокса 
  const handleCheckboxToggle = (id) => {
    setSelectedIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      sortable: false,
      disableColumnMenu: true,
      width: 70,
    },
    {
      field: 'name',
      headerName: 'Назва',
      sortable: false,
      disableColumnMenu: true,
      width: 200,
      renderCell: (params) => {
        const isChecked = selectedIds.includes(params.row.id);

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleCheckboxToggle(params.row.id)}
              style={{
                accentColor: isChecked ? '#227965' : '#ccc',
                cursor: 'pointer',
                width: '20px',
                height: '20px',
              }}
            />
            {params.row.name}
          </div>
        );
      }
    },
    {
      slug: 'type',
      headerName: 'Тип',
      sortable: false,
      disableColumnMenu: true,
      width: 400
    },
    {
      field: "action",
      headerName: "Редагувати",
      sortable: false,
      disableColumnMenu: true,
      sortable: false,


      // renderCell: (params) => {
      //   return <Link to={'/slider/update/' + params.row.id}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
      // }
      renderCell: (params) => {
        return <Link to={'/slider/update/' + params.row.id}><img src="/edit.svg" alt="edit" /></Link>;
      }
    },
  ];




  return (
    <CRow>
      <CCol xs={12}>
        <CCard className="mb-4">
          <CCardHeader className='items_card_header'>Слайдери</CCardHeader>
          <CCardBody>
            <div className='head_items_wrapper_solo'>
              {<p className="text-medium-emphasis small">
                <Link to="/slider/create" className='link_add_button'>
                  {/* Створити */}
                  <CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                    {/* Створити */}
                    Add
                  </CButton>
                </Link>
              </p>}
            </div>
            <div style={{ height: 600, width: '100%' }}>

              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={pageSize}
                rowsPerPageOptions={[postPerPage]}
                // checkboxSelection

                components={{ Pagination: CustomPagination }}
                headerHeight={44}
                getRowClassName={(params) =>
                  selectedIds.includes(params.row.id) ? 'active-row' : ''
                }
                sx={{
                  borderRadius: '12px',
                  border: '1px solid #ccc',

                  '& .MuiDataGrid-main': {
                    // borderRadius: '12px',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    fontSize: '12px',
                    lineheight: '150%',
                    color: '#717680',
                    //   borderBottom: '2px solid #4e73df',

                  },
                  '& .MuiDataGrid-cell': {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#434349',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    // borderBottomLeftRadius: '12px',
                    // borderBottomRightRadius: '12px',
                  },
                }}


              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default Slider;
